import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
    border: '1px solid #F1F1F1',
    borderRadius: '1rem',
    width: '100%',
    minHeight: '175px',
    maxHeight: '175px',
    background:
      'linear-gradient(276deg, rgb(69, 41, 156) 0%, rgb(194, 5, 229) 100%)',
    color: 'white'
  },

  title: {
    textAlign: 'center',
    marginBottom: '1rem',
    width: '100%',
    fontSize: theme.size.base
  },

  children: {
    position: 'relative',
    fontSize: theme.size.xl
  },

  info: {
    position: 'absolute',
    top: '1rem',
    right: '1rem'
  }
}))

export default useStyles
